import Navigation from './components/navigation.js';
import Tooltip from './components/tooltips.js';
import { slideShowNL } from './components/slideshow-nl.js';
import PianoProfile from './components/piano-profile.js';
import WidgetAEX from './widgets/aex.js';
import WidgetLogoCarousel from './widgets/logo-carousel.js';
import WidgetPartnerCarousel from './widgets/partner-carousel.js';
import ModalList from './components/modal-list.js';

(function ($) {
	PianoProfile.init();
	Tooltip.init();
	WidgetAEX.init();
	WidgetLogoCarousel.init();
	WidgetPartnerCarousel.init();

	$(function () {
		Navigation.init();
		ModalList.init(slideShowNL);
	});
})(jQuery); // Fully reference jQuery after this point.
